/**
 * Копирование ссылки в буфер
 */
const copySelector = document.querySelectorAll('.j-copy-link');

if (copySelector.length) {
    copySelector.forEach((item) => {
        item.addEventListener('click', () => {
            const invisibleTextArea = document.createElement('textarea');
            const text = item.querySelector('.j-copy-link-text');

            invisibleTextArea.value = window.location.href;
            invisibleTextArea.classList.add('share__invisible');
            document.body.appendChild(invisibleTextArea);
            invisibleTextArea.select();
            document.execCommand('copy');
            document.body.removeChild(invisibleTextArea);
            text.innerHTML = 'Ссылка скопирована';
        });
    });
}
